class DetailsDisclosure extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    this.querySelector('summary')?.addEventListener(
      'click',
      this.#onSummaryClick,
      { signal: this.#controller.signal }
    );
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  get #details() {
    return this.querySelector('details');
  }

  get #panel() {
    return this.querySelector('.disclosure__panel');
  }

  #onSummaryClick = (event) => {
    const details = this.#details;
    if (!details?.open) return; // Opening is handled by browser + CSS

    event.preventDefault(); // Intercept close to animate first

    details.classList.add('is-closing');

    this.#panel?.addEventListener(
      'transitionend',
      () => {
        details.open = false;
        details.classList.remove('is-closing');
      },
      { once: true }
    );
  };
}

if (!customElements.get('details-disclosure')) {
  customElements.define('details-disclosure', DetailsDisclosure);
}
